import DashboardLayout from "../../../layouts/DashboardLayout";
import CiudadanoDashboard from "../../../components/ciudadano/CiudadanoDashboard/CiudadanoDashboard";

function Dashboard() {
    return (
        <DashboardLayout>
            <CiudadanoDashboard />
        </DashboardLayout>
    );
}

export default Dashboard;
